module.exports = __webpack_public_path__ + "assets/steps-pointer-inverted.2613e5d1.svg";